import { AlarmConsultContent } from "./AlarmConsultContent";
import { AlarmConsultHeader } from "./AlarmConsultHeader";
import { AlarmConsultRoot } from "./AlarmConsultRoot";

export const AlarmConsult = {
  Root: AlarmConsultRoot,
  Header: AlarmConsultHeader,
  Content: AlarmConsultContent,
};
